import React, { Component }  from 'react';
import fallbackImage from "./assets/images/no-media-fallback.jpg";

interface APImageProps {
    imageSrc: string,
    imageFallback: string,
    imageClass: string,
}

interface APImageState {
    src: string,
    imageStatus: string
}

class APImage extends Component<APImageProps, APImageState> {
    
    constructor(props: any) {
        super(props);
        this.state = {
            src: props.imageSrc,
            imageStatus: "loading"
        };
    }

    handleImageLoaded() {
        this.setState({ 
            imageStatus: "loaded"
        });
    }

    handleImageErrored() {
        this.setState({ 
            src: this.props.imageFallback,
            imageStatus: "failed"
        });
    }

    render() {
        const { imageClass } = this.props;
        const { src } = this.state;
        return <img className={imageClass} alt={''} role='img' src={src} onLoad={this.handleImageLoaded.bind(this)} onError={this.handleImageErrored.bind(this)} />
    }

    static defaultProps = { imageFallback: fallbackImage };

}


export default APImage;